import { FC } from 'react'
import { Helmet } from 'react-helmet'

const Dashboard: FC = () => {
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Dashboard</title>
      </Helmet>
      <section>
        <h1 className="py-3 text-center text-3xl font-bold">Welcome to GAG</h1>
      </section>
    </>
  )
}

export default Dashboard
